import { CSSProperties } from 'react';

// NOTE: Hide the Luzmo dashboard while it is loading, as its loading styles cannot be customized at a granular level.
// Do not use `display: none`, as it causes visual artifacts in the iframe after it finishes loading.
export const getInsightsDashboardStyleProps = (
  isDashboardLoading: boolean
): { height: string; style: CSSProperties } => ({
  height: isDashboardLoading ? '0' : 'auto',
  style: {
    visibility: isDashboardLoading ? 'hidden' : 'visible',
  },
});
